module.exports = __webpack_public_path__ + "static/media/3.6ef1d0d7.jpg";